import viewtemplate from "./actionButtonElement.hbs";

export class ActionButtonElement extends HTMLElement {
    private _clickListener;
    constructor() {
        super();
        this.innerHTML = viewtemplate(this.attributesToObject(this.attributes));
    }

    private attributesToObject(attrs: NamedNodeMap) {
        let obj = {};
        for (let i = 0, n = attrs.length; i < n; i++) {
            obj[attrs[i].nodeName] = attrs[i].nodeValue;
        }
        return obj;
    }

    public disable() {
        this.querySelector("button").classList.add("is-disabled");
        this.querySelector("button").setAttribute("aria-disabled", "true");
        this.removeEventListener("click", this._clickListener);
    }
    public enable = () => {
        this.querySelector("button").classList.remove("is-disabled");
        this.querySelector("button").removeAttribute("aria-disabled");
        this.addEventListener("click", this._clickListener);
    }

    public set disabled(disabled) {
        if (disabled) {
            this.disable();
        } else {
            this.enable();
        }
    }

    public set clickListener(clickListener) {
        this._clickListener = clickListener;
    }
}
export function initActionButtonWebComponent() {
    window.customElements.define("s6-action-button", ActionButtonElement);
}
